import { Delete, View } from 'assets/Icons'
import { DateInput, NumberInput } from 'components/Form'
import { Modal, Tooltip } from 'components/Overlay'
import Table from 'components/Table/index'
import notification from 'helpers/notification'
import { prettyPrice } from 'helpers/prettyData'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import services from 'services/index'

const PreviewPayment = ({ data, getGroupById }) => {
	const role = useSelector(state => state?.user?.user?.user_type)
	const [visible, setVisible] = useState(false)
	const [updateData, setUpdateData] = useState(data?.payments)

	const onChangeDate = (date, id) => {
		const currentObj = updateData?.find(item => item?.id === id)
		const filterArr = updateData?.filter(item => item?.id !== id)
		setUpdateData([...filterArr, { ...currentObj, date }])
	}
	const onChangeAmount = (amount, id) => {
		const currentObj = updateData?.find(item => item?.id === id)
		const filterArr = updateData?.filter(item => item?.id !== id)
		setUpdateData([...filterArr, { ...currentObj, amount }])
	}

	const deletePayment = id => {
		const options = {
			id,
			onError: () => notification('Error', { type: 'error' }),
			onSuccess: response => {
				if (response?.status === 204) {
					getGroupById(id)
				}
			},
		}
		services.groups.deletePayment(options)
	}

	const headersModal = [
		{
			key: 'date',
			label: <div className='px-[16px] py-[12px]'>Sana</div>,
			getContent: ({ data, key, index }) => {
				return role === 'admin' || role === 'accountant' ? (
					<div className='w-[150px] sm:w-full'>
						<DateInput
							hideBorder={true}
							value={data?.date}
							onChange={date => onChangeDate(date, data?.id)}
						/>
					</div>
				) : (
					<div className='px-[16px] py-[12px]'>{data?.date}</div>
				)
			},
		},
		{
			key: 'amount',
			label: <div className='px-[16px] py-[12px]'>Summa</div>,
			getContent: ({ data, key, index }) => {
				return role === 'admin' || role === 'accountant' ? (
					<NumberInput
						hideBorder={true}
						value={data?.amount}
						onChange={amount => onChangeAmount(amount, data?.id)}
					/>
				) : (
					<div className='px-[16px] py-[12px]'>{prettyPrice(data?.amount)}</div>
				)
			},
		},
		{
			key: 'id',
			label: (
				<div className='px-[16px] py-[12px] flex justify-center'>Amallar</div>
			),
			getContent: ({ data, key, index }) => {
				return (
					<div className='px-[16px] py-[12px] flex justify-center'>
						<span
							className='text-red-500 cursor-pointer'
							onClick={() => deletePayment(data?.id)}
						>
							<Delete classname={'size-5 sm:size-6'} />
						</span>
					</div>
				)
			},
		},
	]

	const saveGrades = () => {
		updateData?.map((item, index) => {
			const options = {
				data: item,
				id: item?.id,
				onError: () => notification('Error', { type: 'error' }),
				onSuccess: response => {
					if (response?.status === 200) {
						getGroupById(data?.id)
					}
				},
			}
			services.groups.putPayment(options)
		})
		setVisible(false)
		notification("Barcha to'lovlar saqlandi", { type: 'success' })
		getGroupById(data?.id)
	}
	return (
		<div>
			<div className='flex justify-center sm:justify-start items-center'>
				<Tooltip title="To'lovlarni ko'rish" distance={6}>
					<button className='edit-icon' onClick={() => setVisible(true)}>
						<View />
					</button>
				</Tooltip>
			</div>
			<Modal
				onClose={() => setVisible(false)}
				onOpen={() => setVisible(true)}
				open={visible}
			>
				<div className='p-6'>
					<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold mb-4'>
						To'lov ro'yxati
					</h1>
					<Table
						withPadding={false}
						data={updateData?.sort((a, b) => a?.id - b?.id)}
						headers={
							role === 'admin' || role === 'accountant'
								? headersModal
								: headersModal.slice(0, -1)
						}
					/>
					<div className='flex justify-end items-center mt-[24px] gap-3'>
						<button
							className='mute-btn w-full sm:w-[150px]'
							onClick={() => setVisible(false)}
						>
							Yopish
						</button>
						<button
							className='success-btn w-full sm:w-[150px]'
							onClick={saveGrades}
						>
							Saqlash
						</button>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default PreviewPayment
